import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles, Theme, useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    widht: '100%',
    textAlign: 'center',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: '3rem',
    fontFamily: theme.typography.fontFamily,
  },
}));
export default function TituloText(props: any) {
  useTheme();
  const classes = useStyles();

  return (
    <Typography variant="h2" className={classes.root}>
      {props.children}
    </Typography>
  );
}
